export default [
  [`Размер`, `3XS`, `2XS`, `XS`, `S`],
  [`Длина рукава`, `46`, `52`, `58`, `64`],
  [`В груди, полуобхват`, `42`, `44`, `46`, `48`],
  [`Длина`, `48`, `52`, `55`, `58`]
];
